import { usePaging } from 'hooks/usePaging';
import { useGetTicketsInProgressCustomerLookupQuery } from 'services/tickets';
import { FindAllTicketsInProgressCustomerLookupDto } from 'types/dto/ticket/find-all-tickets-in-progress-customer-lookup.dto';

const pageSize = 6;

export function useTicketsInProgressCustomerLookupPaging(
  params: Omit<FindAllTicketsInProgressCustomerLookupDto, 'pageIndex' | 'pageSize'>
) {
  const {
    customerName,
    customerAddress,
    meterSerialNumber,
    customerCode,
    routeCode,
    meterPointCode,
    organizationUnitCode,
    wardId,
    districtId,
    ticketId,
    customerPhoneNumber,
    administrativeUnitId,
    contactId
  } = params;
  const { pageIndex, changePage, resetPage } = usePaging(params);

  // Kiểm tra nếu có giá trị tìm kiếm nào được nhập thì gọi API
  const shouldFetch = !!(
    customerName ||
    customerAddress ||
    meterSerialNumber ||
    customerCode ||
    routeCode ||
    meterPointCode ||
    organizationUnitCode ||
    wardId ||
    districtId ||
    ticketId ||
    customerPhoneNumber ||
    administrativeUnitId ||
    contactId
  );

  const queryParams = shouldFetch
    ? {
        pageIndex,
        pageSize,
        customerName,
        customerAddress,
        meterSerialNumber,
        customerCode,
        routeCode,
        meterPointCode,
        organizationUnitCode,
        wardId,
        ticketId,
        districtId,
        customerPhoneNumber,
        administrativeUnitId,
        contactId
      }
    : {
        pageIndex,
        pageSize,
        customerName: '',
        customerAddress: '',
        meterSerialNumber: '',
        customerCode: '',
        routeCode: '',
        meterPointCode: '',
        organizationUnitCode: '',
        wardId: undefined,
        districtId: undefined,
        ticketId: '',
        customerPhoneNumber: '',
        administrativeUnitId: 0,
        contactId: 0
      };
  const {
    data: ticketsInProgressCustomerLookupResponse,
    error,
    isFetching,
    isLoading
  } = useGetTicketsInProgressCustomerLookupQuery(queryParams, {
    skip: !shouldFetch // Chặn gọi API khi không có giá trị tìm kiếm
  });

  const handleChangePage = changePage;

  return {
    ticketsInProgressCustomerLookup: shouldFetch ? ticketsInProgressCustomerLookupResponse?.data.rows || [] : [],
    count: shouldFetch ? ticketsInProgressCustomerLookupResponse?.data.count || 0 : 0,
    isLoading: shouldFetch && (isFetching || isLoading),
    pageIndex,
    handleChangePage,
    resetPage,
    error
  };
}
